<template>
    <el-menu class="el-menu-vertical"
             :default-active="$store.state.maintabs.activeRoute"
             :unique-opened="uniqueOpened"
             :collapse="isMenuCollapse">

        <div class="menu-top" :style="[{'--back-ground-color':backgroundcolor}]">
          <img :src="logoImg" style="height: 46px;width: 46px">
          <div class="sys-name">{{webTitle}}</div>
        </div>
        <template v-for="menu in menuList">
            <el-submenu  :index="menu.id" :key="menu.id" v-if="!menu.menuHidden" v-show="menu.currentUserType">
                <template slot="title">
                  <i :class="menu.menuIcon"></i>
                  <span slot="title">{{menu.name}}</span>
                </template>

                <router-link v-for="item in menu.children" :to="item.path"
                             :key="item.id" v-if="!item.menuHidden" v-show="menu.currentUserType">
                  <el-menu-item :index="item.path"  :style="[{'--back-ground-color':backgroundcolor}]">
                    <i :class="item.menuIcon"></i>
                      {{item.name}}
                  </el-menu-item>
                </router-link>
            </el-submenu>
        </template>
    </el-menu>
</template>
<style lang="scss">
    .el-menu-vertical:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
    }
    .el-menu.el-menu--collapse {
        .sys-name{
          display: none;
        }
    }
    .el-menu{
        .menu-top{
          width: 100%;
          height: 60px;
          background-color: var(--back-ground-color);
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items:center;
          .sys-name{
            color: #FFFFFF;
            font-size: 20px;
          }
        }
        background-color: #2c2c2c;
        .el-submenu__title,.el-submenu__title>i{
            padding-left: 10px !important;
            color: #FFFFFF;
        }
        .el-menu-item{
            padding-left: 40px !important;
            color: #FFFFFF;
        }
        .el-menu-item.is-active,
        .el-menu-item.is-active:hover
        {
            background-color: var(--back-ground-color);
            color: #FFFFFF
        }
        .el-submenu__title:hover,
        .el-menu-item:hover{
            border-left:  6px solid #FFFFFF;
            background-color: var(--back-ground-color);
        }
    }

    [class^="el-icon-fa"], [class*="el-icon-fa"] {
      display: inline-block;
      font: normal normal normal 17px/1 FontAwesome!important;
      font-size: inherit;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    $fa-css-prefix: el-icon-fa;
</style>

<script>
    import {queryThemeStyleInfo} from "../../api/b2cbusiness/b2c_websetting";

    export default {
        name:"LayoutMenu",
        data(){
            return {
              uniqueOpened: true,
              logoImg:require('@/assets/logo.png'),
              backgroundcolor: '#1F9FFF',
              webTitle: '推客'
            }
        },
        props:{
            isMenuCollapse:{
                type: Boolean
            }
        },
        computed:{
            menuList(){
                return this.$store.state.maintabs.menuList;
            }
        },
      mounted() {
        queryThemeStyleInfo().then(res=>{
          if (res.success && res.data != null){
            this.backgroundcolor = res.data.themeStyle!=null?res.data.themeStyle:'#1F9FFF';
            this.logoImg = res.data.salemanWebLogo!=null?res.data.salemanWebLogo:require('@/assets/logo.png');
            this.webTitle = res.data.webTitle;
            document.title= this.webTitle;
          }
        });
      },
    }
</script>
